import { http } from '../http';
export class UserApis {
  static login(data) {
    return http('api/user/login', {
      method: 'POST',
      data
    });
  }
  static getUserInfo() {
    return http('api/user/userInfo');
  }
}